import { useSyncExternalStore } from 'react';

export interface GeoLocationState {
  countryCode: string | null;
  regionCode: string | null;
  loading: boolean;
  error: Error | null;
}
function readCookie(name: string): string {
  if (typeof document === 'undefined') return '';
  try {
    const cookie = document.cookie.split('; ').find(value => value.startsWith(`${name}=`));
    return cookie ? decodeURIComponent(cookie.slice(cookie.indexOf('=') + 1)).toUpperCase() : '';
  } catch { return ''; }
}
function subscribe(listener: () => void) {
  window.addEventListener('focus', listener);
  window.addEventListener('pageshow', listener);
  window.addEventListener('consentSaved', listener);
  return () => {
    window.removeEventListener('focus', listener);
    window.removeEventListener('pageshow', listener);
    window.removeEventListener('consentSaved', listener);
  };
}
// First-party edge cookies only; unknown location never grants optional analytics.
export const useGeoLocation = (): GeoLocationState => {
  const countryCode = useSyncExternalStore(subscribe, () => readCookie('user_country'), () => '');
  const regionCode = useSyncExternalStore(subscribe, () => readCookie('user_region'), () => '');
  return { countryCode: /^[A-Z]{2}$/.test(countryCode) && countryCode !== 'XX' ? countryCode : null,
    regionCode: /^[A-Z0-9-]{1,8}$/.test(regionCode) ? regionCode : null, loading: false, error: null };
};
